import "slick-carousel/slick/slick";

// var prize_slider = jQuery(".prize-slider");
// var prize_slider_description = jQuery(".prize-slider-description");

jQuery(document).ready(function () {

	if (jQuery(".prize-slider").length > 0) {
		jQuery(".prize-slider").slick({
			arrows: false,
			dots: true,
			mobileFirst: true,
			infinite: true,
			variableWidth: true,
			centerMode: true,
			slidesToScroll: 1,
			asNavFor: jQuery(".prize-slider-description")
		});

		jQuery(".prize-slider-description").slick({
			arrows: false,
			dots: false,
			fade: true,
			mobileFirst: true,
			infinite: true,
			slidesToScroll: 1,
			asNavFor: jQuery(".prize-slider")
		});
	}


});
